import * as React from 'react';
import SectionList from 'src/components/Section/SectionList';

const ChooseSection: React.SFC = ({ match }: any) => (
  <div className="container">
    <div className="col-lg-6 centered">
      <h1>Themenbereich auswählen</h1>
      <SectionList linkBase={match.url} />
    </div>
  </div>
);
export default ChooseSection;



// WEBPACK FOOTER //
// ./src/pages/Management/EventManagement/ChooseSection.tsx